__turbopack_context__.v({
  "container": "xId0hG_container",
  "fullPage": "xId0hG_fullPage",
});
